<template>
<div
   v-closable="{ exclude: ['ContextItemEditableInput'], isClosable: true, handler: 'handleCancelEditing'}"
  >
    <div :ref="'ContextItemEditableInput'"
      class="context--item--editable--input--wrapper"
      :class="{'hovered': isEditing}"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div @[eventName]="handleGlobalEditing" class="context--item--editable--input--container" :class="[{'editing': isEditing}]">
        <div v-if="icon !== null" class="icon">
          <v-tooltip left :disabled="iconTooltip === null">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">{{ icon }}</v-icon>
            </template>
            <span>{{ iconTooltip }}</span>
          </v-tooltip>
        </div>
        <slot name="custom--icon" />
        <span
        v-show="!isEditing && !isLink"
        :class="[title ? 'title' : 'value', localValue === null || localValue === '' ? 'empty-value' : '']"
        >{{ localValue === null || localValue === '' ? emptyValue : localValue }}</span>
        <a v-show="!isEditing && isLink" class="value" :class="{'disabled--link': localValue === null}" :href="computedHref" target="_blank">
          {{ localValue === null || localValue === '' ? emptyValue : localValue }}
        </a>
        <template>
          <input
          :class="{'title': title}"
          v-show="isEditing"
          :value="localValue"
          :ref="'wrld_editable_input'"
          @input="handleInput($event)"
          v-on="listeners"
          :type="inputType"
          />
        </template>
      </div>
      <div v-show="hover" class="actions--panel">
        <template v-if="!isEditing">
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="14" @click="handleEditing"> fas fa-pen</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </div>
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" @click="handleCopy"> far fa-copy</v-icon>
              </template>
              <span :key="copied">{{copied ? 'Copied' : 'Copy'}}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-else>
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="14" @click="handleCancelEditing"> fas fa-times</v-icon>
              </template>
              <span>Cancel</span>
            </v-tooltip>
          </div>
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="14" @click="handleSaveEditing"> fas fa-save</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { generalHelpers } from '@/_helpers'

export default {
  name: 'ContextItemEditableInput',
  props: {
    icon: { type: String, default: null },
    iconTooltip: { type: String, default: null },
    value: { value: String | Number, default: null },
    emptyValue: { type: String, default: 'Add Value' },
    eventName: { type: String, default: '' },
    extraActions: { type: Array, default: () => null },
    title: { type: Boolean, default: false },
    isLink: { type: Boolean, default: false },
    savedByEnter: { type: Boolean, default: false },
    inputType: { type: String, default: 'text' }
  },
  data () {
    return {
      hover: false,
      isEditing: false,
      localValue: null,
      copied: false
    }
  },
  mounted () {
    this.localValue = this.value
  },
  methods: {
    handleEditing () {
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.hover = true
        this.$nextTick(() => {
          this.$refs['wrld_editable_input'].focus()
        })
      }
    },
    handleSaveEditing (evt) {
      this.$emit('save-emitted', this.localValue)
      this.isEditing = false
      this.hover = false
    },
    handleCancelEditing (evt) {
      if (this.isEditing) {
        this.localValue = this.value
      }
      this.isEditing = false
      this.hover = false
    },
    handleGlobalEditing (evt) {
      if (evt.target.tagName !== 'A') {
        if (!this.isEditing) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.$refs['wrld_editable_input'].focus()
            })
          }, 100)
        }
        this.hover = true
        this.isEditing = true
      }
    },
    handleInput (evt, index) {
      this.localValue = evt.target.value
      this.$emit('input-emitted', this.localValue)
    },
    handleCopy () {
      this.copied = true
      generalHelpers.copyToClipboard(this.value)
    }
  },
  computed: {
    computedHref () {
      if (this.localValue !== null) {
        if (this.inputType === 'text') {
          return this.localValue.includes('http') ? this.localValue : `https://${this.localValue}`
        }
      }
      return null
    },
    listeners () {
      if (this.savedByEnter) {
        return { keyup: (event) => {
          if (event.key === 'Enter') {
            this.handleSaveEditing()
          }
        } }
      } else {
        return {}
      }
    }
  },
  watch: {
    copied: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          setTimeout((self = this) => {
            self.copied = false
          }, 3000)
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        this.localValue = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context--item--editable--input--wrapper {
  position: relative;
  border-radius: 5px;
   width: 100%;
  &.hovered {
     background-color: #f2f2f2;
  }
  &:hover {
    background-color: #f2f2f2;
  }
  .context--item--editable--input--container {
    position: relative;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: nowrap;
    align-items: left;
    justify-content: flex-start;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-bottom: 1px;
    &.editing {
      border-color: #767676;
    }
    .icon {
      i {
        color: #767676;
        font-size: 16px;
      }
      flex: 1 1 10%;
      margin-right: 15px;
      max-width: 16px;
    }
    .value {
      &.empty-value {
        color: #767676 !important;
      }
      color: #484848;
      font-size: 13px;
      font-weight: bold;
      flex: 1 1 max-content;
      margin-right: 5px;
      padding-top: 2px;
      &.disabled--link {
        pointer-events: none;
        cursor: default;
      }
    }
    .title {
      padding-top: 5px;
      flex: 1 1 max-content;
      margin-right: 5px;
      margin-left: 5px;
    }
    input {
      flex: 1 1 auto;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      border-radius: 0;
      -moz-border-radius: 0;
      -webkit-border-radius: 0;
      outline: none;
      border: none;
      background-color: #ededed;
      color: inherit;
      font-family: inherit;
      color: #484848;
      font-size: 13px;
      font-weight: bold;
      width: 40px;
      &.title {
        font-size: 20px;
        padding-top: 0;
      }
    }
  }
  .actions--panel {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 9;
    background-color: #f2f2f2;
    height: calc(100% - 5px);
    display: flex;
    border-left: 1px solid #ededed;

    .icon-action {
      position: relative;
      top: 0;
      width: 20px;
      height: 20px;
      text-align: center;
      border-radius: 5px;
      i {
        color: #767676;
        font-size: 16px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
}
</style>
